import React, { useEffect, useState } from 'react'
import { Sidenav } from '../SideNav/Sidenav'
import { CustomNavbar } from '../CustomNavbar/customnabar'
import { FeedbackHeader } from './Widgets/FeedbackHeader'
import './Feedback.css';
import { MdOutlineMoreHoriz } from 'react-icons/md'
import { FeedbackClass } from '../../APIs/ServiceClass/Feedback';
import { Menu, MenuItem } from '@mui/material';
import FeedbackModal from './Modal/FeedbackModal';
import { useNavigate } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Layout from '../../ReuseComponent/Layout/Layout';


export const Feedback = () => {


    const feedbackclass = new FeedbackClass();
    const [feedbacks, setFeedbacks] = useState([]);
    const [feedback, setFeedback] = useState(null);

    const [updatingStatus, setUpdatingStatus] = useState(false);
    
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClickMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };


    //Updating Dialog

    const [openD, setOpen] = useState(false);
    const handleCloseD = () => {
        setOpen(false);
    };

    const [updatemsg, setUpdateMsg] = useState("");

    //Updating Dialog

    const [modal, setModal] = useState(false);

    const updateFeedbackStatus = (item, status, text)=>{

        setUpdatingStatus(true); setUpdateMsg("");

        setOpen(true);
        
        feedbackclass.updateFeedbackStatus({
            "feedback_id":item.id,
            "status": status
        }).then((value)=>{ 

            setUpdateMsg("");
        
            setFeedbacks([...feedbacks].map((val) =>
                 val.id === item.id ? { ...val, status: (text)} : val
            )); 

            handleCloseMenu(); handleCloseD();

            console.log(value); 

        }).catch((error)=>{
            console.log(error); setUpdatingStatus(false); setUpdateMsg("Failed to update status");
            if (error.response.status === 401) navigate('/login')
        });

    }

    useEffect(() => {
        feedbackclass.getAllFeedbacks().then((value) => {
            console.log(value); setFeedbacks(value.data.data);
        }).catch((error) => {
            console.log(error);
            if (error.response.status === 401) navigate('/login')
        });
    }, []);


   
    return (
        <div>
            <Layout label={"Feed back"}>

                <div>

                    <FeedbackHeader />

                    <div className='bordered-table' style={{overflowY:"scroll"}}>

                        <table className='table'>

                            <thead>
                                <td style={{ textAlign: "start" }}>Name</td>
                                <td>Feedback Type</td>
                                <td>Date</td>
                                <td>Details</td>
                                <td>Action</td>
                            </thead>
                            
                            {feedbacks.map((item) => <tr key={item.id}>
                                <td style={{ textAlign: "start" }}>
                                    <div className='user-row'>

                                        <div className='dp'>
                                            <img src={item.image} width="100%" height="100%" />
                                        </div>

                                        <div className='user-details' style={{cursor:"pointer"}} onClick={()=>navigate("/feedbacks",{state:item})} >
                                            <p style={{ color: "black" }}>{item.f_name + " " + item.l_name}</p>
                                            <p>{item.description}</p>
                                        </div>

                                    </div>
                                </td>
                                <td style={{color: (item.name==="15")?"green":"red"}}>{item.name}</td>
                                <td style={{ color: "black" }}>{new Date(item.created_at).toString().substring(0, 15)}</td>
                                <td style={{ fontSize: "12px", color: "#608E75" }}><span onClick={()=>{
                                    setFeedback(item);
                                    setModal(true)}}>View details</span></td>
                                <td><div onClick={(e)=>{handleClickMenu(e); setFeedback(item)}} className='action'>

                                    {console.log(item.slug)}
                                    
                                    {item.status.toString().toLowerCase()==="default" && <MdOutlineMoreHoriz />}
                                    {item.status.toString().toLowerCase()==="fixed" && <span style={{color:"green", fontSize:"12px",padding:"2px"}}>{item.status}</span>}
                                    {item.status.toString().toLowerCase()==="in progress" && <span style={{color:"orange", fontSize:"12px",padding:"2px"}}>{item.status}</span>}
                                    {item.status.toString().toLowerCase()==="unresolved" && <span style={{color:"red", fontSize:"12px",padding:"2px"}}>{item.status}</span>}
                                    {item.status.toString().toLowerCase()==="acknowledged" && <span style={{color:"#608E75", fontSize:"12px",padding:"2px"}}>{item.status}</span>}
                                    
                                    </div></td>
                            </tr>)}

                            

                        </table>


                        {(feedback!==null) && <FeedbackModal open={modal} close={()=>setModal(false)} feedback={feedback} />}

                    </div>

                    {console.log(feedback)}

                </div>

                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleCloseMenu}
                    style={{ left: "-7vw", textAlign: "center" }}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    <MenuItem onClick={()=>{
                                    updateFeedbackStatus(feedback, 14, "Fixed")
                                    }} className='menu-text'><span style={{ fontSize: "13px", color: "green" }}><center>Fixed</center></span></MenuItem>

                    <MenuItem onClick={()=>{
                                    updateFeedbackStatus(feedback, 24, "In Progress")
                                    }} className='menu-text'><span style={{ fontSize: "13px", color: "orange" }}>In Progress</span></MenuItem>

                    <MenuItem onClick={()=>{
                                updateFeedbackStatus(feedback, 34, "Unresolved")
                                    }} className='menu-text'><span style={{ fontSize: "13px", color: "red" }}>Unresolved</span></MenuItem>

                    <MenuItem onClick={()=>{
                                    updateFeedbackStatus(feedback, 44, "Acknowledged")
                                    }} className='menu-text'><span style={{ fontSize: "13px", color: "#608E75" }}>Acknowledge</span></MenuItem>


                </Menu>


            </Layout>

            <Dialog
                open={openD}
                onClose={handleCloseD}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >

                <DialogContent>
                    <center>
                        <div style={{ width: "200px", padding: "30px" }}>

                            <p className="dialog-text" >Updating feedback status</p>
                            <br></br>

                            {(updatemsg==="") && <div class="sk-bounce">
                                <div class="sk-bounce-dot" style={{ backgroundColor: "#4c6356" }}></div>
                                <div class="sk-bounce-dot" style={{ backgroundColor: "#4c6356" }}></div>
                            </div>}

                            {
                                (updatemsg!=="") && updatemsg
                            }

                        </div>
                    </center>
                </DialogContent>

            </Dialog>

        </div>
    )
}
